"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("../NavHeader/userInfoState"));
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const styled_1 = __importDefault(require("@emotion/styled"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1({ open, setOpen, }) {
    const closeDialog = () => setOpen(false);
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    const { isLoggedIn } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(CreateDialog, Object.assign({ open: open, onClose: closeDialog }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px 0',
                    lineHeight: '22px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 0.8)',
                } }, { children: [t('만들기'), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => setOpen(false), css: {
                            position: 'absolute',
                            right: '20px',
                            padding: '1px',
                            backgroundColor: '#F8F8F8',
                            backdropFilter: 'blur(2px)',
                        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderCloseSvg, {}) }))] })), (0, jsx_runtime_1.jsxs)(CreateButton, Object.assign({ onClick: () => {
                    if (isLoggedIn)
                        (0, functions_1.goToCreateRoom)();
                    else
                        window.location.href = (0, string_utils_1.loginReturnPath)('/room/room_create_new/');
                    setOpen(false);
                } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.FireCrackerSvg, {}), t('판매시작')] })), (0, jsx_runtime_1.jsxs)(CreateButton, Object.assign({ onClick: () => {
                    if (isLoggedIn)
                        window.location.href = '/room/demand-create';
                    else
                        window.location.href = (0, string_utils_1.loginReturnPath)('/room/demand-create');
                    setOpen(false);
                } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.SurveyBoardSvg, {}), t('수요조사')] })), (0, jsx_runtime_1.jsxs)(CreateButton, Object.assign({ onClick: () => {
                    if (isLoggedIn)
                        window.location.href = '/room/commission-create';
                    else
                        window.location.href = (0, string_utils_1.loginReturnPath)('/room/commission-create');
                    setOpen(false);
                } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.CommissionHandSvg, {}), t('커미션'), (0, jsx_runtime_1.jsx)(components_1.BetaTag, {})] }))] })));
}
exports.default = default_1;
const CreateDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiDialog-scrollPaper {
    align-items: flex-end;
  }
  .MuiDialog-paper {
    row-gap: 8px;
    width: 100%;
    max-width: 800px;
    padding-bottom: 40px;
    border-radius: 20px 20px 0 0;
    margin: 0;
  }
`;
const CreateButton = (0, styled_1.default)(Button_1.default) `
  display: flex;
  justify-content: flex-start;
  min-height: 56px;
  column-gap: 8px;
  padding: 8px 16px;
  background-color: white !important;
  line-height: 1;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
  #new_logo_wrapper {
    display: flex;
    padding: 6px 8px;
    background-color: #ee7744;
    border-radius: 100px;
  }
`;
